import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { RouteNames } from '../../routing/app-routing.constants';
import Lottie from 'lottie-web';
import { HelperService } from '../../services/helper.service';
import { SessionService } from '../../../core/services/session.service';
import { SessionKeys } from '../../models/SessionKeys';
import { APIFailure } from '../../../core/models/context';
import { ContextService } from '../../../modules/context/services/context.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss']
})
export class ErrorScreenComponent implements OnInit {

  tipTitle: string;
  title: string;
  imageUrl: string;
  desc: string;
  primaryButtonText: string;
  isPrimaryBtnBlue: boolean;
  isSecondaryButtonVisible: boolean;
  isPrimaryButtonVisible: boolean;
  isImageLarge: boolean;
  isAuthFlowFailure: boolean;
  failedAPI: string;
  isCtaVisible: boolean;
  constructor(
    private readonly router: Router,
    private readonly helperService: HelperService,
    private readonly sessionService: SessionService,
    private contextService : ContextService
  ){
    this.isAuthFlowFailure = (this.router.getCurrentNavigation()?.extras?.state?.isAuthFlowFailure) as boolean;
    this.failedAPI = (this.router.getCurrentNavigation()?.extras?.state?.api) as string; 
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationStart) {
       if(event.navigationTrigger === 'popstate') {
        this.helperService.createSession(SessionKeys.isFromComeBackLater, 'true'); 
       }
      }
    })
    
    if (this.router.url.includes(RouteNames.ErrorScreen)){
      this.tipTitle = 'ErrorScreen.TipTitle';
      this.title = 'ErrorScreen.Title';
      this.imageUrl = './assets/images/ErrorScreen.svg';
      this.desc = 'ErrorScreen.Description';
      this.primaryButtonText = 'ErrorScreen.PrimaryButtonText';
      this.isPrimaryBtnBlue = false;
      this.isSecondaryButtonVisible = false;
      this.isImageLarge = true;
      const isFromComeBackLater = this.helperService.getSessionValue(SessionKeys.isFromComeBackLater);
      this.isCtaVisible = (isFromComeBackLater === 'true') ? false : true;
    } else if (this.router.url.includes(RouteNames.ComeBackLater)){
      this.tipTitle = 'ComeBackLater.TipTitle';
      this.title = 'ComeBackLater.Title';
      this.imageUrl = './assets/images/come-back-later.svg';
      this.desc = 'ComeBackLater.Description';
      this.isCtaVisible = false;
      this.isImageLarge = true;   
    } 
    
  }
  ngAfterViewInit(): void {
    if (this.imageUrl.includes('json')){
      const svgContainer = document.getElementById('jsonImageIcon');
      Lottie.loadAnimation(this.helperService.getLottieConfig(svgContainer, false, true, 'no-product', this.imageUrl));
    }
  }
  nextAction(event: string): void {
    if(event === 'forward') {
      if(this.isAuthFlowFailure){        
        this.sessionService.authenticate();
        this.helperService.createSession(SessionKeys.isRetryOver, 'true');             
      } else if(this.failedAPI === APIFailure.GetValidationParametersAPI) {
        void this.router.navigate(['/' + RouteNames.simulation]);
      } else if(this.failedAPI === APIFailure.RetrievePersonDetailsAPI) {
        this.contextService.retrievePersonDetails();
      } else if(this.failedAPI === APIFailure.IsSubscriptionAllowedAPI){
        this.contextService.IsSubscriptionAllowed(localStorage.getItem('uci'));
      } else if(this.failedAPI === APIFailure.CreateUserAPI){
        this.contextService.createUser(localStorage.getItem('uci'));
      } else if( this.failedAPI === APIFailure.UserLogin){
        this.contextService.loginUser(localStorage.getItem('uci'));
      } else if( this.failedAPI === APIFailure.isContactAndTOUAvailable){
        this.contextService.isContactAndTOUAvailable();
      } else if(this.failedAPI === APIFailure.GetTermsOfUseConsent){
        void this.router.navigate(['/' + RouteNames.customerZone + '/' + RouteNames.customerHome]);
      } else if(this.failedAPI === APIFailure.ValidatePerson){
        this.contextService.OnlinePaymentDeeplink();
      }
    }
  }
}
